export const customerName = (customer) => {
  if (!customer) return null;
  console.log(customer);
  return customer.type === 2
    ? customer.orgNameShort
    : `${customer.firstName} ${customer.lastName}`;
}

